<div aria-label="pdfBackupPage">
  <div class="backgroundWhite" tabindex="0">
    <div class="pr-96px pr-1-25 pb-1rem padding-right-96px">
      <div class="pt-1 pr-1-25">
        <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont content-display pb-1" [innerHTML]="header"></h1>

        <div class="pt-1" *ngIf="showcaptchaView && !isproviewuser">
          <div>
            <p class="usageText1" [innerHTML]="Termandcondition">
            </p>
          </div>
          
        <div class="recaptcha" *ngIf="siteKey">
          <form [formGroup]="aFormGroup">
            <ngx-recaptcha2 #captchaElem
                            id="recaptchabasic"
                            siteKey={{siteKey}}
                            (success)="onCaptchaSuccess($event)"
                            (error)="onCaptchaError()"
                            (expire)="onCaptchaError()"
                            formControlName="recaptcha">
            </ngx-recaptcha2>
          </form>
        </div>
        <div class="basic-access-btn">
          <button class="btn-secondary-disabled-basic btn-l-basic" id="btnPdfView" disabled (click)="accessPdfView()">
            {{accessPdfViewButton}}
          </button>
        </div>
        <div class="usageText">
          <span class="p-16-basic">{{usageText}}</span>
        </div>
        <div class="usageText1">
          <span class="p-16-basic">
            {{additionalInfo}} <span [innerHTML]="contactGASBSupport"></span>
          </span>
        </div>
      </div>
      </div>
      <div *ngIf="isAccessSucess || isproviewuser">
        <div class="pt-1 pr-1-25">
          <p class="answerHome font-16 content-blue width-100 margin-top-1" [innerHTML]="content"></p>
        </div>
        <div class="pdf-backup-container">
          <mat-tree #tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
              <span class="font-16 singleLine" *ngIf="node.itemLink == null">{{node.item}}</span>
              <span class="highlight-blue border-bottom-help cursor-pointer singleLine" *ngIf="node.itemLink != null" (click)="navigateToUrl(node.itemLink)">{{node.item}}</span>
            </mat-tree-node>
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
              <div class="mat-tree-node">
                <button mat-icon-button matTreeNodeToggle
                        [attr.aria-label]="'Toggle ' + node.item">
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>
                <span class="font-16 singleLine">{{node.item}}</span>
              </div>
              <div [class.example-tree-invisible]="!treeControl.isExpanded(node)"
                   role="group">
                <ng-container matTreeNodeOutlet></ng-container>
              </div>
            </mat-nested-tree-node>
          </mat-tree>
        </div>
      </div>
     
    </div>
  </div>
</div>

